import { ApolloClient, InMemoryCache } from '@klappir/data/graphql';

import { GRAPHCMS_WEB_API_URL } from './config';

export const web = new ApolloClient({
  uri: GRAPHCMS_WEB_API_URL,
  cache: new InMemoryCache(),
});
